<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>用户基本信息</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <el-button class="el-icon-plus" type="primary" @click="showCreate"
          >添加用户</el-button
        >
        <el-select
          :value="queryType"
          @change="setQueryType"
          placeholder="请选择账户类型"
        >
          <el-option
            v-for="item in queryTypeList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>

        <el-input placeholder="请输入内容" clearable v-model="queryValue">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>

        <el-select v-model="tenantId" placeholder="租户选择" clearable>
          <el-option
            v-for="item in tenantList"
            :key="item.id"
            :label="item.tenantName"
            :value="item.id"
          >
          </el-option>
        </el-select>

        <el-input placeholder="请输入真实姓名" clearable v-model="realName">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-select v-model="userStatus" placeholder="请选择用户状态">
          <el-option>请选择</el-option>
          <el-option
            v-for="item in status"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-select v-model="userType" placeholder="请选择用户类型">
          <el-option>请选择</el-option>
          <el-option
            v-for="item in Shareholder"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-select v-model="mark" placeholder="请筛选异常账户">
          <el-option>全部</el-option>
          <el-option
            v-for="item in ifMark"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-button type="primary" @click="handleSearch">搜索</el-button>
      </div>
      <user-list @refresh="refreshList"></user-list>
      <Create @refresh="refreshList"></Create>
      <UpdateDialog :val="userinfoDetail" @refresh="refreshList" />
    </el-card>
  </div>
</template>

<script>
import "./store";
import UserList from "./components/list";
import Create from "./components/create/index.vue";
import { mapState, mapActions, mapMutations } from "vuex";
import { QUERY_TYPE, PAGINATION } from "./constants";
import { tenantInfo } from "@/common/publicApi";
import UpdateDialog from "./components/updatedialog/index.vue";
export default {
  name: "User",
  components: {
    UserList,
    Create,
    UpdateDialog,
  },
  data() {
    return {
      isShow: false,
      queryValue: "",
      realName: "",
      userStatus: "",
      userType: "",
      mark: null,
      tenantId: "",
      status: [
        { value: 0, label: "激活" },
        { value: "-1", label: "冻结" },
      ],
      Shareholder: [
        { value: 1, label: "模拟盘用户" },
        { value: 2, label: "普通用户" },
        { value: 3, label: "特殊账户" },
      ],
      // Shareholder: [
      //   { value: '1', label: '无效用户' },
      //   { value: '2', label: '普通用户' },
      //   { value: '3', label: '初级股东' },
      //   { value: '4', label: '中级股东' },
      //   { value: '5', label: '高级股东' }
      // ],
      ifMark: [
        { value: true, label: "异常账户" },
        { value: false, label: "非异常账户" },
      ],
      tenantList: [],
    };
  },
  computed: {
    ...mapState("userOld", [
      "queryType",
      "queryTypeList",
      "pagination",
      "userinfoDetail",
    ]),
  },
  methods: {
    ...mapActions("userOld", ["list"]),
    ...mapMutations("userOld", ["setQueryType", "setCreateVisible"]),
    refreshList(data = {}) {
      this.list({
        queryType: this.queryType,
        queryValue: this.queryValue,
        realName: this.realName,
        userStatus: this.userStatus,
        userType: this.userType,
        tenantId: this.tenantId,
        ...this.pagination,
        ...data,
      });
    },
    showCreate() {
      this.setCreateVisible(true);
    },
    handleSearch() {
      this.list({
        queryType: this.queryType,
        queryValue: this.queryValue,
        realName: this.realName,
        userType: this.userType,
        userStatus: this.userStatus,
        mark: this.mark,
        tenantId: this.tenantId,
        ...PAGINATION,
      });
    },
  },
  mounted() {
    tenantInfo().then((res) => {
      if (res.code == 0) {
        this.tenantList = res.data;
      }
    });
    this.list({
      queryType: QUERY_TYPE[0].value,
      queryValue: this.queryValue,
      realName: this.realName,
      userStatus: this.userStatus,
      userType: this.userType,
      tenantId: this.tenantId,
      ...PAGINATION,
    });
  },
};
</script>

<style lang="less" scoped>
.page-actions {
  margin-bottom: 10px;
}
</style>
